import { auth, firestore } from "./firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  GoogleAuthProvider,
  signInWithPopup,
  onAuthStateChanged
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";

export const registerWithEmail = async (email, password, fullName) => {
  const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  const user = userCredential.user;
  await setDoc(doc(firestore, "users", user.uid), { fullName, email });
  return user;
};

export const loginWithEmail = async (email, password) => {
  const userCredential = await signInWithEmailAndPassword(auth, email, password);
  return userCredential.user;
};

export const loginWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  if (result?.user) {
    const user = result.user;
    await setDoc(doc(firestore, "users", user.uid), {
      fullName: user.displayName || "",
      email: user.email,
    }, { merge: true });
  }
  return result;
};

export const handleGoogleRedirect = async () => {
  // No-op: redirect flow replaced by popup
  return null;
};

export const logout = () => signOut(auth);

export const getCurrentUserId = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      if (user) resolve(user.uid);
      else reject(new Error("User not authenticated"));
    });
  });
};

export { auth };
